/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeProject_Projects.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Project Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Saturday, June 15, 2019 - 01:06:32 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      06/15/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const PROJECT_LIST_CONTAINER_LOADED = 'PROJECT_LIST_CONTAINER_LOADED';
export const PROJECT_LIST_CONTAINER_UNLOADED = 'PROJECT_LIST_CONTAINER_UNLOADED';
export const PROJECT_LIST_TABLE_LOADED = 'PROJECT_LIST_TABLE_LOADED';
export const PROJECT_LIST_TABLE_UNLOADED = 'PROJECT_LIST_TABLE_UNLOADED';

export const PROJECT_LIST_CHANGE_GROUP = 'PROJECT_LIST_CHANGE_GROUP';
export const PROJECT_SELECT_ROW = 'PROJECT_SELECT_ROW';

export const PROJECT_ADD = 'PROJECT_ADD';
export const PROJECT_EDIT = 'PROJECT_EDIT';
export const PROJECT_DELETE = 'PROJECT_DELETE';
export const PROJECT_OPEN_WARNING = 'PROJECT_OPEN_WARNING';
export const PROJECT_CLOSE_WARNING = 'PROJECT_CLOSE_WARNING';
export const PROJECT_DELETE_DISABLE = 'PROJECT_DELETE_DISABLE';
export const PROJECT_VIEW_CHILD_ITEMS = 'PROJECT_VIEW_CHILD_ITEMS';

export const PROJECT_EDIT_CONTAINER_LOADED = 'PROJECT_EDIT_CONTAINER_LOADED';
export const PROJECT_EDIT_CONTAINER_UNLOADED = 'PROJECT_EDIT_CONTAINER_UNLOADED';
export const PROJECT_EDIT_FORM_LOADED = 'PROJECT_EDIT_FORM_LOADED';
export const PROJECT_EDIT_FORM_UNLOADED = 'PROJECT_EDIT_FORM_UNLOADED';
export const PROJECT_UPDATE_VALUE = 'PROJECT_UPDATE_VALUE';

export const PROJECT_SET_GROUP_SELECT = 'PROJECT_SET_GROUP_SELECT';
export const PROJECT_EDIT_DATA_LOAD = 'PROJECT_EDIT_DATA_LOAD';

export const PROJECT_EDIT_CONTAINER_SUBMIT = 'PROJECT_EDIT_CONTAINER_SUBMIT';
export const PROJECT_EDIT_CONTAINER_CANCEL = 'PROJECT_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeProject_Projects.js